module.exports = "/_next/static/images/7c81374af3b48cbfd11abd2637e3d1c8-hourglass.svg.webp";